import { Typography } from '@shared/ui/typography/typography';
import { COLORS } from '../../../../../shared/config/colors/colors';
import { Link } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    border-radius: 20px;
    flex-direction: column;
    background-color: ${COLORS.neutral_00};
`;

export const Line = styled('div')`
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
`;

export const Divider = styled('div')`
    margin: 23px 0;
    height: 1px;
    background: ${COLORS.neutral_20};
`;

export const PriceTag = styled('div')`
    display: flex;
    flex-shrink: 0;
    align-items: center;
`;

export const SubmitDescriptionWrapper = styled('div')`
    margin-top: 12px;
`;

export const SubmitDescription = styled(Typography)`
    & > * {
        display: inline;
    }
`;

export const SubmitLink = styled(Link)`
    display: inline;
`;

export const Footer = styled('div')`
    display: flex;
    margin-top: 40px;
    gap: 12px;
    flex-direction: column;
`;
